import Microgame from '../engine/Microgame.js';

export default class CatchGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Attrape !`, en: `Catch!`, es: `¡Atrapa!` },
            controls: { fr: `Glisse gauche/droite pour déplacer le panier (clique/flèches)`, en: `Swipe left/right to move the basket`, es: `Desliza a los lados para mover la cesta` },
            objective: { fr: `Attrape les objets qui tombent, évite les crânes rouges`, en: `Catch falling objects, avoid red skulls`, es: `Atrapa los objetos que caen, evita las calaveras` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="2"><path d="M3 6h18M3 6l2 12h14l2-12"/><path d="M8 6V4a2 2 0 0 1 4 0v2"/></svg>`,
            actions: [
                { type: 'move', x: 50, y: 86, duration: 420 },
                { type: 'wait', duration: 1500 },
                { type: 'wait', duration: 500 },
            ],
            loopDuration: 3000
        };
    }
    constructor(engine) {
        super(engine);
        this.paddle = null;
        this.object = null;
        this.isDragging = false;
        this.caught = false;

        // --- GAME PARAMETERS ---
        this.duration = 4000; // Base duration reference in ms
        this.baseSpeed = 500; // Base px per second for falling object
        // -----------------------

        this.speed = this.baseSpeed;
        // Timer shown by default
    }

    setup() {
        this.engine.ui.instruction.textContent = "CATCH!";

        // Scale difficulty based on available time
        // The less time we have (higher game speed multiplier), the faster the object falls.
        const timeRatio = Math.max(0.1, this.engine.maxTime / this.duration);
        this.speed = this.baseSpeed / timeRatio;

        // Paddle
        this.paddle = document.createElement('div');
        this.paddle.style.position = 'absolute';
        this.paddle.style.bottom = '50px';
        this.paddle.style.left = '50%';
        this.paddle.style.transform = 'translateX(-50%)';
        this.paddle.style.width = '80px';
        this.paddle.style.height = '20px';
        this.paddle.style.background = this.primaryColor;
        this.paddle.style.borderRadius = '10px';
        this.paddle.style.boxShadow = `0 0 10px ${this.primaryColor}`;
        this.container.appendChild(this.paddle);

        // Falling Object
        this.object = document.createElement('div');
        this.object.style.position = 'absolute';
        this.object.style.top = '-50px';
        // Use container width, not window width
        const maxWidth = this.container.clientWidth - 40;
        this.object.style.left = this.isPlayback ? `${(maxWidth / 2)}px` : `${Math.random() * maxWidth}px`;
        this.object.style.width = '40px';
        this.object.style.height = '40px';
        this.object.style.background = this.secondaryColor;
        this.object.style.borderRadius = '50%';
        this.object.style.boxShadow = `0 0 10px ${this.secondaryColor}`;
        this.container.appendChild(this.object);

        // Events
        this.onMove = this.onMove.bind(this);
        this.engine.input.element.addEventListener('mousemove', this.onMove);
        this.engine.input.element.addEventListener('touchmove', this.onMove);
    }

    onMove(e) {
        if (!this.active) return;

        let x;
        if (e.touches) {
            x = e.touches[0].clientX;
        } else {
            x = e.clientX;
        }

        // Clamp paddle
        const rect = this.container.getBoundingClientRect();
        const relX = x - rect.left;
        this.paddle.style.left = `${relX}px`;
    }

    update(dt) {
        if (!this.active || this.caught) return;

        const top = parseFloat(this.object.style.top);
        const newTop = top + (this.speed * (dt / 1000));
        this.object.style.top = `${newTop}px`;

        // Check Catch
        const pRect = this.paddle.getBoundingClientRect();
        const oRect = this.object.getBoundingClientRect();

        if (this.isColliding(pRect, oRect)) {
            // Infinite / Time Attack Logic
            if (this.engine.activeChallenge && (this.engine.activeChallenge.mode === 'infinite' || (this.engine.activeChallenge.config && this.engine.activeChallenge.config.timeAttack))) {
                this.engine.score++;
                this.engine.updateHUD();

                // Reset object to top
                this.object.style.top = '-50px';
                const maxWidth = this.container.clientWidth - 40;
                this.object.style.left = `${Math.random() * maxWidth}px`;

                // Increase speed slightly?
                this.speed += 20;
            } else {
                this.caught = true;
                this.object.style.display = 'none';
                this.win();
            }
        }

        // Check Miss
        if (newTop > window.innerHeight) {
            this.lose();
        }
    }

    isColliding(r1, r2) {
        return !(r2.left > r1.right ||
            r2.right < r1.left ||
            r2.top > r1.bottom ||
            r2.bottom < r1.top);
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('mousemove', this.onMove);
        this.engine.input.element.removeEventListener('touchmove', this.onMove);
    }
}
